module.exports = __webpack_public_path__ + "84bfa9dce7c7aab1d2d757866ca0d2ec.pdf";